"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function lsk(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M10.6869 19.0935C10.6764 19.104 10.6554 19.1145 10.6449 19.125H9.48088C9.45988 19.125 9.44938 19.1145 9.43888 19.104L6.00764 15.228C6.00264 15.2184 6.00003 15.2077 6.00003 15.1969C6.00003 15.186 6.00264 15.1754 6.00764 15.1658L10.2811 7.7895C10.3021 7.75875 10.3539 7.75875 10.3749 7.7895L11.5704 9.858C11.5809 9.8685 11.5809 9.8895 11.5704 9.9105L8.67988 14.8942C8.66938 14.9145 8.67988 14.9355 8.69038 14.9565L10.4161 16.8998C10.4277 16.9109 10.4423 16.9182 10.4581 16.9208H12.4959C12.5484 16.9208 12.5686 16.9733 12.5371 17.004L10.6869 19.0935ZM11.9544 4.9065C11.9761 4.8645 12.0279 4.8645 12.0384 4.9065L17.9956 15.144C18.0061 15.1657 17.9956 15.1867 17.9851 15.207L14.5546 19.083C14.5431 19.0941 14.5284 19.1014 14.5126 19.104H11.7264C11.6739 19.104 11.6536 19.0515 11.6851 19.0208L13.5459 16.9103L15.2926 14.946C15.3136 14.925 15.3136 14.904 15.3031 14.8837L11.9964 9.17925L10.7491 7.02675C10.7386 7.017 10.7386 6.996 10.7491 6.97425L11.9544 4.9065Z", fill: color }));
}
exports["default"] = lsk;
//# sourceMappingURL=lsk.js.map